import { render, staticRenderFns } from "./shift_details.vue?vue&type=template&id=67eb3606&scoped=true&"
import script from "./shift_details.vue?vue&type=script&lang=js&"
export * from "./shift_details.vue?vue&type=script&lang=js&"
import style0 from "./shift_details.vue?vue&type=style&index=0&id=67eb3606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb3606",
  null
  
)

export default component.exports